import { Controller } from '@hotwired/stimulus';
import { useCifraClient } from '@/api/cifra-client';

const { cifraClient } = useCifraClient();

/**
 * Rellena un select de evaluaciones según el curso seleccionado en un SelectorEstructura.
 */
export default class extends Controller {
  connect() {
    const selectorEstructuraQuery = this.element.dataset.selectorEstructura;
    if (selectorEstructuraQuery) {
      this.selectorEstructura = document.querySelector(selectorEstructuraQuery);
      this.#conectarSelectorEstructura();
    }
  }

  limpiarSelect() {
    this.element.innerHTML = '';
    const option = document.createElement('option');
    option.value = '';
    option.text = '';
    this.element.add(option);
  }

  cargarEvaluaciones(cursoId) {
    this.limpiarSelect();
    if (!cursoId) return;

    cifraClient.get('/evaluaciones/json', { params: { curso_id: cursoId } }).then((response) => {
      response.data.forEach((evaluacion) => {
        const option = document.createElement('option');
        option.text = evaluacion.nombre;
        option.value = evaluacion.id;
        this.element.add(option);
      });
    });
  }

  #conectarSelectorEstructura() {
    if (!this.selectorEstructura) return;

    this.selectorEstructura.addEventListener('change', (event) => {
      const { tipo, idSeleccionado } = event.detail;
      if (tipo === 'curso' && idSeleccionado) {
        this.cargarEvaluaciones(idSeleccionado);
      } else {
        this.limpiarSelect();
      }
    });

    this.selectorEstructura.addEventListener('limpiar-seleccion', () => {
      this.limpiarSelect();
    });
  }
}
